<template>
  <!--<div>-->
  <div class="homeMain">
    <!--banner+导航-->
    <div class="bannerBox">

      <!--<img  ref="homeBanner" src="../../../assets/img/homeBanner.jpg"/>-->

      <video muted width="100%" height="" autoplay loop  >
        <source src="../../../assets/img/bannerVideo_1.mp4"  type="video/mp4"  >
        <!--您的浏览器不支持 video 标签-->
        <img  ref="homeBanner" src="../../../assets/img/homeBanner.jpg"/>
      </video>


      <div class="topTextBox">
        <!--导航-->
        <top-nav></top-nav>
        <!-- <div class="contentW bannerText1"><img src="../../../assets/icon/logo2.png"/></div> -->
         <div class="contentW bannerText1"><img src="../../../assets/icon/Banner Main@2x.png"/></div>
        <div class="contentW bannerText2"></div>
        <div class="contentW bannerText3" style="overflow: visible;"  @click="navClick('/zh-hans/contact')"><span >联系我们</span></div>
      </div>
    </div>
    <!--板块1-->
    <div class="index01" id="m1">
      <div class="contentW animated" :class="animates.mm1 ? 'fadeInUp' : 'hideBox'">
        <div class="content_left_title">支付解决方案</div>
        <div class="tabsBox">
          <div class="tabsTitle">
            <span :class="act.tabsTitleId===1 ? 'act' : ''" @click="tabsTitleClick(1)">线下支付</span>
            <span :class="act.tabsTitleId===2 ? 'act' : ''" @click="tabsTitleClick(2)">线上支付</span>
          </div>
          <div class="tabsContent">
            <ul v-if="act.tabsTitleId===1">
              <li class="iconLi" @mouseenter="enter1(1,1)" @mouseleave="leave1(1,0)">
                <div v-show="show.shows1===0" class="borderDiv">
                  <div class="iconDiv"><img src="../../../assets/icon/home_instore1.png"/></div>
                  <div class="textDiv">店内二维码</div>
                </div>
                <div v-show="show.ids1===1 && show.shows1===1" class="borderDiv border">
                  <div class="textTitle">店内二维码</div>
                  <div class="textContent">消费者可以通过扫描店内静态二维码，并输入所购商品金额以进行付款</div>
                </div>
              </li>
              <li class="iconLi" @mouseenter="enter2(2,1)" @mouseleave="leave2(2,0)">
                <div v-show="show.shows2===0" class="borderDiv">
                  <div class="iconDiv"><img src="../../../assets/icon/home_instore2.png"/></div>
                  <div class="textDiv">智能移动收款机</div>
                </div>
                <div v-show="show.ids2===2 && show.shows2===1" class="borderDiv border">
                  <div class="textTitle">智能移动收款机</div>
                  <div class="textContent">智能移动收款机可以生成动态二维码由消费者扫码支付，或者扫取消费者支付宝/微信支付付款码直接收款</div>
                </div>
              </li>
              <li class="iconLi" @mouseenter="enter3(3,1)" @mouseleave="leave3(3,0)">
                <div v-show="show.shows3===0" class="borderDiv">
                  <div class="iconDiv"><img src="../../../assets/icon/home_instore3.png"/></div>
                  <div class="textDiv">POS零售系统商</div>
                </div>
                <div v-show="show.ids3===3 && show.shows3===1" class="borderDiv border">
                  <div class="textTitle">POS零售系统商</div>
                  <div class="textContent">我们支持商户将自家使用的POS系统接入SuperiorPay支付，拥有SuperiorPay POS系统的同样功能</div>
                </div>
              </li>
              <li class="iconLi">
                <div class="borderDiv">
                  <div class="btnDiv"  @click="navClick('/zh-hans/contact')">联系我们</div>
                </div>
              </li>
            </ul>
            <ul v-if="act.tabsTitleId===2">
              <li class="iconLi" @mouseenter="enter1(1,1)" @mouseleave="leave1(1,0)">
                <div v-show="show.shows1===0" class="borderDiv">
                  <div class="iconDiv"><img src="../../../assets/icon/home_online1.png"/></div>
                  <div class="textDiv">第三方收银台</div>
                </div>
                <div v-show="show.ids1===1 && show.shows1===1" class="borderDiv border">
                  <div class="textTitle">第三方收银台</div>
                  <div class="textContent">用于PC端口，用户在PC端网页跳转支付宝/微信支付第三方收银页面进行支付</div>
                </div>
              </li>
              <li class="iconLi" @mouseenter="enter2(2,1)" @mouseleave="leave2(2,0)">
                <div v-show="show.shows2===0" class="borderDiv">
                  <div class="iconDiv"><img src="../../../assets/icon/home_online2.png"/></div>
                  <div class="textDiv">H5端口</div>
                </div>
                <div v-show="show.ids2===2 && show.shows2===1" class="borderDiv border">
                  <div class="textTitle">H5端口</div>
                  <div class="textContent">用于移动设备端口，用户与移动端网页付款，并跳转支付宝/微信支付App内进行支付</div>
                </div>
              </li>
              <li class="iconLi" @mouseenter="enter3(3,1)" @mouseleave="leave3(3,0)">
                <div  v-show="show.shows3===0" class="borderDiv">
                  <div class="iconDiv"><img src="../../../assets/icon/home_online3.png"/></div>
                  <div class="textDiv">SDK端口</div>
                </div>
                <div v-show="show.ids3===3 && show.shows3===1" class="borderDiv border">
                  <div class="textTitle">SDK端口</div>
                  <div class="textContent">用于移动设备App端口，用户直接在设备App内进行支付</div>
                </div>
              </li>
              <li class="iconLi" @mouseenter="enter4(4,1)" @mouseleave="leave4(4,0)">
                <div v-show="show.shows4===0" class="borderDiv">
                  <div class="iconDiv"><img src="../../../assets/icon/home_online4.png"/></div>
                  <div class="textDiv">JSAPI端口</div>
                </div>
                <div v-show="show.ids4===4 && show.shows4===1" class="borderDiv border">
                  <div class="textTitle">JSAPI端口</div>
                  <div class="textContent">用于移动设备App内小程序端口，用户可以在小程序内直接进行支付</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--板块2-->
    <div class="index02" id="m2">
      <div class="contentW animated" :class="animates.mm2 ? 'fadeInUp' : 'hideBox'">
        <div class="content_center_title">你知道吗？</div>
        <div class="contentBox">
          <div class="text1">中国是澳大利亚最大，最有价值的入境游客市场。在截至2018年9月的一年中，短期中国游客前往该国旅行了130万人次，并向澳大利亚游客经济体提供了115亿澳元。</div>
          <ul class="index02Ul">
            <li class="index02Li leftLi">
              <div class="div80">
                <div class="title">中国支付生态：</div>
                <div class="content">根据Ipsos最近的一项调查：第三方移动支付用户研究报告。据统计，中国有超过9.4亿活跃的移动支付用户。</div>
                <div class="btnDiv">
                  <div class="btn1" @click="linkDownload('/digial_sales_kit_cn.pdf')" >了解更多</div>
                  <div class="btn2" @click="navClick('/zh-hans/contact')">申请</div>
                </div>
              </div>
            </li>
            <li class="index02Li centerLi">
              <div class="div80">
                <div class="centerText">不同付款方式的交易份<br/>额占比图</div>
              </div>
            </li>
            <li class="index02Li rightLi">
              <div class="div80">
                <div class="rowBox">
                  <img src="../../../assets/icon/home_index2_icon1.png"/>线下移动支付 - 41%
                </div>
                <div class="rowBox">
                  <img src="../../../assets/icon/home_index2_icon2.png"/>线上移动支付 - 19%
                </div>
                <div class="rowBox">
                  <img src="../../../assets/icon/home_index2_icon3.png"/>线下银行卡支付 - 16%
                </div>
                <div class="rowBox">
                  <img src="../../../assets/icon/home_index2_icon4.png"/>线上银行卡支付 - 14%
                </div>
                <div class="rowBox">
                  <img src="../../../assets/icon/home_index2_icon5.png"/>其他 - 16%
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--板块3-->
    <div class="index03" id="m3">
      <div class="contentW animated" :class="animates.mm3 ? 'fadeInUp' : 'hideBox'">
        <div class="content_center_title">我们的优势</div>
        <div class="contentBox">
          <ul>
            <li>
              <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon1.png"/></div>
              <div class="textDiv">免费注册无额外费用</div>
            </li>
            <li>
              <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon2.png"/></div>
              <div class="textDiv">无需额外设立支付宝或微信账户</div>
            </li>
            <li>
              <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon3.png"/></div>
              <div class="textDiv">'T+1' 自动清算</div>
            </li>
            <li>
              <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon4.png"/></div>
              <div class="textDiv">商户交易额不受限</div>
            </li>
          </ul>
          <ul>
            <li>
              <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon5.png"/></div>
              <div class="textDiv">澳洲顶级银行资金管理</div>
            </li>
            <li>
              <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon6.png"/></div>
              <div class="textDiv">网页&App账户后台管理</div>
            </li>
            <li>
              <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon7.png"/></div>
              <div class="textDiv">一站式多平台营销，快速引流</div>
            </li>
            <li>
              <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon8.png"/></div>
              <div class="textDiv">24小时在线客服</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--板块 add2019-09-18-->
    <div class="index06" id="m4">
      <div class="contentW animated" :class="animates.mm4 ? 'fadeInUp' : 'hideBox'">
        <div class="content_center_title">合作伙伴</div>
        <div class="contentBox">SuperiorPay希望为客户提供简单，⽅便和可定制的聚合⽀付解决⽅案，使客户⽆论在任地⽅，任何时间，能以任何⽅式进⾏付款。⽬前SuperiorPay已集成众多主流⽀付⽅式，包括但不限于微信⽀付、⽀付宝。</div>
        <div class="btn" @click="navClick('/PartnersCn')">了解更多</div>
        <ul class="logoUl">
          <li><img src="../../../assets/icon/Citibank.png" width="153px" height="40px"></li>
          <li><img src="../../../assets/icon/unionpay.png" width="98px" height="61px"/></li>
          <li><img src="../../../assets/icon/tenpay.png" width="152px" height="53px"/></li>
          <li><img src="../../../assets/icon/antpay.png" width="134px" height="65px"/></li>
        </ul>
      </div>
    </div>
    <!--板块4-->
    <div class="index04" id="m4">
      <div class="contentW animated" :class="animates.mm4 ? 'fadeInUp' : 'hideBox'">
        <div class="content_center_title">POS系统对接支持</div>
        <div class="contentBox">SuperiorPay与澳大利亚本地POS系统供应商合作，包括Blueshyft，Futura，EasyCloud，IPOS，PosPal，2Dfire，TapTouch和MustardBoat，实现系统集成，结算管理，退款管理等，确保客户获得全面的跨境支付服务</div>
        <div class="btn" @click="navClick('/zh-hans/contact')">申请</div>
      </div>
      <div class="logoBox">
        <ul class="logoUl contentW">
          <li><img src="../../../assets/icon/new_logo_1.png"/></li>
          <li><img src="../../../assets/icon/new_logo_2.png"/></li>
          <li><img src="../../../assets/icon/new_logo_3.png"/></li>
          <li><img src="../../../assets/icon/new_logo_4.png"/></li>
          <li><img src="../../../assets/icon/new_logo_5.png"/></li>
        </ul>
        <ul class="logoUl logoUl02 contentW">
          <!-- <li><img src="../../../assets/icon/new_logo_6.png"/></li> -->
          <li><img src="../../../assets/icon/new_logo_7.png"/></li>
          <li><img src="../../../assets/icon/new_logo_8.png"/></li>
          <li><img src="../../../assets/icon/new_logo_9.png"/></li>
        </ul>

      </div>
    </div>
    <!--板块5-->
    <div class="index05" id="m5" v-show="false">
      <div class="contentW animated" :class="animates.mm5 ? 'fadeInUp' : 'hideBox'" style="width: 1102px;">
        <ul class="index5Ul">
          <li class="index5Li">
            <div class="mapBox"><img src="../../../assets/img/home_map_img1.png"/></div>
            <div class="mapTitle">悉尼办公室</div>
            <div class="mapContent">Suite 2304<br/> Level 23, 66 Goulburn St <br/>Sydney NSW 2000<!-- <br/> 联系方式:1300 066 006 --></div>
          </li>
          <li class="index5Li">
            <div class="mapBox"><img src="../../../assets/img/home_map_img2.png"/></div>
            <div class="mapTitle">墨尔本办公室</div>
            <div class="mapContent">201, Level 2B<br/> 818 Whitehorse Rd<br/> Box Hill VIC 3128</div>
          </li>
          <li class="index5Li">
            <div class="mapBox"><img src="../../../assets/img/home_map_img3.png"/></div>
            <div class="mapTitle">阿德莱德办公室</div>
            <div class="mapContent">177 Gilbert street, Adelaide, SA <br/> 5000 <!-- <br/>联系方式: 1300 066 006 --></div>
          </li>
        </ul>
      </div>
    </div>

    <!--底部-->
    <Footer></Footer>

  </div>

  <!--</div>-->
</template>

<script>
  import topNav from './navCn'
  import Footer from "@/components/Footer"
  let timer = null; //定义初始值
  export default {
    name: "homeCn",
    components:{topNav,Footer},
    props:{
      step:{   //此数据是控制动画快慢的
        type:Number,
        default:50
      }
    },

    data(){
      return {
        style:{
          bannerH:{
            height:"",
          }
        },
        act:{
          tabsTitleId:1,
        },
        show:{
          ids1:0,
          shows1:0,
          ids2:0,
          shows2:0,
          ids3:0,
          shows3:0,
          ids4:0,
          shows4:0,
        },
        animates:{
          mm1:false,
          mm2:false,
          mm3:false,
          mm4:false,
          mm5:false,
          mm6:false,
        },
      }
    },
    destroyed(){
      window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
    },
    mounted () {
      document.documentElement.scrollTop=0;

      if(window.innerWidth>1200){
        window.addEventListener('scroll', this.handleScroll)
      }else {
        this.animates.mm1 = true;
        this.animates.mm2 = true;
        this.animates.mm3 = true;
        this.animates.mm4 = true;
        this.animates.mm5 = true;
      }

    },
    created(){

    },
    methods:{
      //  点击导航
      navClick(url){
        this.$router.push(url);
      },

      //打开新连接
      linkDownload (url) {
        window.open(url,'_blank') // 新窗口打开外链接
      },

      //鼠标滑动动画
      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        var offsetTop1 = document.querySelector('#m1').offsetTop;
        var offsetTop2 = document.querySelector('#m2').offsetTop;
        var offsetTop3 = document.querySelector('#m3').offsetTop;
        var offsetTop4 = document.querySelector('#m4').offsetTop;
        var offsetTop5 = document.querySelector('#m5').offsetTop;


        if (scrollTop > offsetTop1-700) {
          this.animates.mm1 = true
        } else {
          this.animates.mm1 = false
        }
        if (scrollTop > offsetTop2-700) {
          this.animates.mm2 = true
        } else {
          this.animates.mm2 = false
        }
        if (scrollTop > offsetTop3-700) {
          this.animates.mm3 = true
        } else {
          this.animates.mm3 = false
        }
        if (scrollTop > offsetTop4-700) {
          this.animates.mm4 = true
        } else {
          this.animates.mm4 = false
        }
        if (scrollTop > offsetTop5-700) {
          this.animates.mm5 = true
        } else {
          this.animates.mm5 = false
        }
      },


      //  tabs切换
      tabsTitleClick(index){
        this.act.tabsTitleId=index;
      },

      //置顶
      toTop(){ // 动画

        timer = setInterval(function () {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
          // this.isTop = true
          if (osTop === 0) {
            clearInterval(timer)
          }
        },30)

      },
      //  板块1鼠标移入移出
      enter1(id,show){
        this.show.ids1 = id;
        this.show.shows1 = show;
      },
      leave1(id,show){
        this.show.ids1 = id;
        this.show.shows1 = show;
      },
      enter2(id,show){
        this.show.ids2 = id;
        this.show.shows2 = show;
      },
      leave2(id,show){
        this.show.ids2 = id;
        this.show.shows2 = show;
      },
      enter3(id,show){
        this.show.ids3 = id;
        this.show.shows3 = show;
      },
      leave3(id,show){
        this.show.ids3 = id;
        this.show.shows3 = show;
      },
      enter4(id,show){
        this.show.ids4 = id;
        this.show.shows4 = show;
      },
      leave4(id,show){
        this.show.ids4 = id;
        this.show.shows4 = show;
      }




    },
  }
</script>

<style scoped>



  .homeMain{width: 100%;height: auto;}
  .homeMain .bannerBox{width: 100%;height: auto;position: relative;}
  .homeMain .bannerBox>img{width: 100%;}
  .homeMain .bannerBox .topTextBox{width: 100%;height: 100%;position: absolute;top: 0;left: 0;}
  .homeMain .bannerBox .topTextBox .bannerText1{height: 7rem;text-align: center;margin-top: 16.5%;}
  .homeMain .bannerBox .topTextBox .bannerText1>img{width: 14rem;}
  .homeMain .bannerBox .topTextBox .bannerText2{font-size: 1.25rem;color: #fff;text-align: center;height: 22%;font-family: PingFangRegular;}
  .homeMain .bannerBox .topTextBox .bannerText3{font-size: 1.25rem;color: rgba(255,255,255,0.6);text-align: center;cursor: pointer;}
  .homeMain .bannerBox .topTextBox .bannerText3>span{width: 150px;height: 56px;line-height: 56px;display: inline-block; border: 1px solid rgba(255,255,255,0.6);font-family: PingFangRegular;font-weight: 500;}
  .homeMain .bannerBox .topTextBox .bannerText3>span:hover{color: #fff;border: 1px solid #fff;transition: all 0.5s ease-in-out;}


  /*内容部分左侧标题*/
  .content_left_title{font-size: 1.5rem;color: #4a4a4a;height: 5rem;line-height: 5rem;width: 100%;font-family: PingFangRegular;font-weight: 600;}
  .content_center_title{font-size: 2.25rem;color: #4a4a4a;height: 5rem;line-height: 5rem;width: 100%;text-align: center;font-family: PingFangRegular;font-weight: 500;}

  /*板块1*/
  .index01{height: auto;background-color: #fff;padding: 7rem 0;}
  .index01 .tabsBox{width: 100%;height: auto;}
  .index01 .tabsBox .tabsTitle{width: 100%;height: 2rem;line-height: 2rem; border-bottom: 1px solid #dbdbdb;font-family: PingFangRegular;font-weight: 500;}
  .index01 .tabsBox .tabsTitle>span{font-size: 1rem;color: #4a4a4a;padding:0 0.7rem;display: inline-block;margin-right: 1rem;cursor: pointer;}
  .index01 .tabsBox .tabsTitle>span.act{border-bottom: 2px solid #f05423;}
  .index01 .tabsBox .tabsContent{width: 100%;height: 16rem;}
  .index01 .tabsBox .tabsContent>ul{width: 100%;height: 100%;}
  .index01 .tabsBox .tabsContent>ul .iconLi{width: 25%;height: 100%;float: left;cursor: pointer;}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv{width: 80%;height: calc(100% - 2px);}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv .iconDiv{width: 100%;text-align: center;margin-top: 5rem;margin-bottom: 1rem;height: 6rem;}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv .iconDiv>img{}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv .textDiv{width: 100%;text-align: center;font-size: 1rem;color: #4a4a4a;font-family: PingFangRegular;font-weight: 500;}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv .btnDiv{margin:6.5rem auto; color: #fff;font-size: 0.97rem;background-color: #083358;font-family: PingFangRegular;width: 8rem;text-align: center;border-radius: 4px; height: 2.5rem;line-height: 2.5rem;cursor: pointer;}

  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv.border{
    box-shadow:
      -2px 0 7px -1px #dadada,
      0 -2px 0px -1px rgba(0,0,0,0),
      0 2px 7px -1px #dadada,
      2px 0 7px -1px #dadada;
    padding-top: 1rem;
  }
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv.border .textTitle{width: 10rem;margin:auto; font-family: PingFangMedium;font-weight: 600;font-size: 1rem;color: #4a4a4a;text-align: center;line-height: 3rem;}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv.border .textContent{width: 10rem;margin: auto;font-family: PingFangMedium;font-weight: 500; font-size: 0.875rem;color: #515151;text-align: center;line-height: 1.5rem;}


  /*板块2*/
  .index02{height: auto;background-color: #f6f6f6;padding: 4rem 0;}
  .index02 .contentBox{width: 100%;height: auto;}
  .index02 .contentBox .text1{width: 43rem;font-size: 0.875rem;font-family:PingFangRegular;font-weight: 500; color: #4a4a4a;text-align: center;margin: auto;line-height: 1.5rem;height: auto;}
  .index02 .contentBox .index02Ul{width: 100%;height: 17rem;margin-top: 5rem;}
  .index02 .contentBox .index02Ul .index02Li{float: left;width: 33.33%;height: 100%;overflow: hidden;}
  .index02 .contentBox .index02Ul .index02Li.leftLi{}
  .index02 .contentBox .index02Ul .index02Li.leftLi .div80{width: 17rem;height: 100%; margin: auto;}
  .index02 .contentBox .index02Ul .index02Li.leftLi .title{font-size: 0.875rem;font-family: PingFangRegular;font-weight: 600; color: #4a4a4a;text-align: center;line-height: 2.5rem;}
  .index02 .contentBox .index02Ul .index02Li.leftLi .content{font-size: 0.875rem;color: #4a4a4a;font-family:PingFangRegular;font-weight: 500;  text-align: center;line-height: 1.5rem;margin-top: 1rem;}
  .index02 .contentBox .index02Ul .index02Li.leftLi .btnDiv{width: 100%;height:2.5rem;margin-top: 2rem; }
  .index02 .contentBox .index02Ul .index02Li.leftLi .btnDiv .btn1{font-family: PingFangMedium;font-weight: 500; width: 6.875rem;line-height: 2.5rem;text-align: center;font-size: 1rem;float: left;color: #4a4a4a;border: 1px solid #4a4a4a;border-radius: 4px;font-weight: 500;cursor: pointer;}
  .index02 .contentBox .index02Ul .index02Li.leftLi .btnDiv .btn2{font-family: PingFangMedium;font-weight: 500;width: 6.875rem;line-height: 2.5rem;text-align: center;font-size: 1rem;float: right;color: #fff;border: 1px solid #083358;background-color: #083358; border-radius: 4px;font-weight: 500;cursor: pointer;}
  .index02 .contentBox .index02Ul .index02Li.centerLi .div80{background: url("../../../assets/icon/home_index2_yuan.png") no-repeat center center;width: 17rem;height: 100%;display: flex;align-items: center;background-size: 100% 100%;margin: auto;}
  .index02 .contentBox .index02Ul .index02Li.centerLi .centerText{font-family:PingFangMedium;width:100%;height: 3.9rem;align-items: center;text-align: center;font-size: 0.875rem;color: #4a4a4a;line-height: 1.3rem;}
  .index02 .contentBox .index02Ul .index02Li.rightLi .div80{width: 19rem;height: 100%; margin: auto;}
  .index02 .contentBox .index02Ul .index02Li.rightLi .rowBox{font-family:PingFangMedium;font-size: 0.875rem;color: #4a4a4a;display: flex;align-items: center;margin-bottom: 2rem;}
  .index02 .contentBox .index02Ul .index02Li.rightLi .rowBox>img{margin-right: 1rem;}


  /*板块3*/
  .index03{height: auto;background-color: #fff;padding: 7rem 0;}
  .index03 .contentBox{width: 100%;height: 25rem;}
  .index03 .contentBox>ul{width: 100%;height: 50%;}
  .index03 .contentBox>ul>li{float: left;width:calc(25% - 10rem);height: calc(100% - 2rem);padding: 1rem 5rem; }
  .index03 .contentBox>ul>li .iconDiv{width: 100%;height: 6rem;text-align: center;margin-top: 1rem;display: flex;align-items: center;}
  .index03 .contentBox>ul>li .iconDiv>img{align-items: center;margin: auto;}
  .index03 .contentBox>ul>li .textDiv{width: 100%;font-size: 0.875rem;color: #6d7278;text-align: center;line-height: 1.3rem;font-family: PingFangMedium;}

  /*板块4*/
  .index04{height: auto;background-color: #181818;padding: 4rem 0 0;}
  .index04 .content_center_title{color: #fff;}
  .index04 .contentBox{width: 50%;margin:2rem auto;color: #fff;font-size: 0.875rem;text-align: center;line-height: 1.5rem;font-family:PingFangRegular;}
  .index04 .btn{width: 6.875rem;line-height: 2.5rem;margin: 4rem auto;font-size: 0.875rem;color: rgba(255,255,255,0.6);cursor: pointer; border: 1px solid rgba(255,255,255,0.6);border-radius: 4px;text-align: center;font-family: PingFangRegular;}
  .index04 .btn:hover{color: #fff;border-color: #fff;transition: all 0.5s ease-in-out; }
  .index04 .logoBox{background: #fff;padding: 46px 0 40px 0;height: 260px;}
  .index04 .logoBox .logoUl{height: 100px;}
  .index04 .logoBox .logoUl>li{width: 20%;height: 100%;display: inline-block;}
  .index04 .logoBox .logoUl>li>img{align-items: center;margin: auto;}
  .index04 .logoBox .logoUl02{margin-top:60px;text-align: center;}

  /*板块add2019-09-18*/
  .index06{height: auto;background-color: #FAFAFA;padding: 4rem 0;}
  .index06 .content_center_title{color: #4A4A4A;}
  .index06 .contentBox{width: 50%;margin:2rem auto;color: #4A4A4A;font-size: 0.875rem;text-align: center;line-height: 1.5rem;font-family:PingFangRegular;}
  .index06 .btn{width: 6.875rem;line-height: 2.5rem;margin: 4rem auto;font-size: 0.875rem;color: #4A4A4A;cursor: pointer; border: 1px solid #4A4A4A;border-radius: 4px;text-align: center;font-family: PingFangRegular;}
  .index06 .btn:hover{color: #4A4A4A;border-color: #4A4A4A;transition: all 0.5s ease-in-out; }
  .index06 .logoUl{width: 100%;height: 4rem;}
  .index06 .logoUl>li{float: left;width: 25%;height: 100%;display: flex;align-items: center;}
  .index06 .logoUl>li>img{align-items: center;margin: auto;}

  /*板块5*/
  .index05{height: auto;background-color: #f6f6f6;padding: 149px 0;}
  .index05 .index5Ul{width: 100%;height: 29rem;}
  .index05 .index5Ul .index5Li{width: 33.3%;height: 100%;float: left;}
  .index05 .index5Ul .index5Li .mapBox{width: 19rem;height: 19rem;border-radius: 50%;display: flex;align-items: center;overflow: hidden;margin: auto;}
  .index05 .index5Ul .index5Li .mapBox>img{align-items: center;margin: auto;}
  .index05 .index5Ul .index5Li .mapTitle{width: 17rem;height: 3rem;line-height: 3rem;margin: auto; font-family:PingFangRegular;font-weight: 600;text-align: center;font-size: 0.875rem;color: #515151;}
  .index05 .index5Ul .index5Li .mapContent{width: 13rem;height: auto; line-height: 1.5rem;margin: auto; font-family:PingFangMedium;text-align: center;font-size: 0.875rem;color: #515151;}

  .hideBox{display: none;}


  @media screen and (max-width: 1600px) {
    .homeMain .bannerBox .topTextBox .bannerText2{height: 15%}
  }
.uline{
  /* height:1px; */
  margin-top: 10px;
  border-bottom: #4a4a4a 1px solid;
}
.privacy {
  /* border-top: #4a4a4a 1px solid; */
  margin-top: 10px;
}
</style>
